<template>
  <h3
    class="text-3xl lg:text-5xl text-secondary-color"
  >
    <slot />
  </h3>
</template>

<script>
  export default {
    name: 'SectionHeader',
    props: {
      invert: {
        type: Boolean
      }
    }
  };
</script>
